import Swal from "sweetalert2";

export const question = (title, text) => {
  return Swal.fire({
    title,
    text,
    icon: "question",
    showCancelButton: true,
  });
};

export const toast = (title, icon = "info", timer = 3500) => {
  if (typeof title === "object" && title?.title && title?.icon) {
    // Eğer yanlışlıkla obje geçildiyse düzelt
    icon = title.icon;
    title = title.title;
  }

  Swal.fire({
    position: "top-end",
    icon: icon || "info", // desteklenen: success, warning, question, error, info
    title,
    showConfirmButton: false,
    timer,
  });
};
